import { Injectable } from '@angular/core';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef
} from '@angular/material/dialog';
import { FileItem } from '@authority-labs/api-interfaces';
import { DirectoryDialogComponent } from './directory-dialog.component';
import { DirectoryFiles } from './directory-files.model';

@Injectable({
  providedIn: 'root'
})
export class DirectoryDialogService {
  private dialogConfig: MatDialogConfig;

  constructor(private dialog: MatDialog) {
    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.minWidth = '40vw';
  }

  selectFiles(
    orderId: number,
    ignoredFiles: string[] = []
  ): MatDialogRef<DirectoryDialogComponent, FileItem[]> {
    const data: DirectoryFiles = {
      orderId: orderId,
      multiple: true,
      filesIds: ignoredFiles
    };
    this.dialogConfig.data = data;
    return this.dialog.open(DirectoryDialogComponent, this.dialogConfig);
  }

  selectFile(
    orderId: number,
    ignoredFiles: string[] = []
  ): MatDialogRef<DirectoryDialogComponent, FileItem> {
    const data: DirectoryFiles = {
      orderId: orderId,
      multiple: false,
      filesIds: ignoredFiles
    };
    this.dialogConfig.data = data;
    return this.dialog.open(DirectoryDialogComponent, this.dialogConfig);
  }
}
